

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { WorkflowStepFormComponent } from './workflowstep-form/workflowstep-form.component';
import { WorkflowStepComponent } from './workflowstep.component';
import { WorkflowStepRoutes } from './workflowstep.routing';

export function declaration() {
    return [WorkflowStepComponent, WorkflowStepFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class WorkflowStepModule {
}

@NgModule({
    imports: [WorkflowStepModule, WorkflowStepRoutes],
    exports: [WorkflowStepModule]
})
export class WorkflowStepWithRouteModule {
}
